export const COMMENT_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSecv6GQGDjUVkzCZQuw23kK64M5gBEwE24NcFBEWMgNHs8PIA/viewform?usp=header'

/** Ghost Special City newsletter — custom domain; sf-special-city.ghost.io redirects here. */
export const GHOST_SIGNUP_SITE = 'https://specialcity.sfheritage.org/'
export const GHOST_SIGNUP_SCRIPT =
  'https://cdn.jsdelivr.net/ghost/signup-form@~0.3/umd/signup-form.min.js'
export const GHOST_SIGNUP_LABEL = 'Doolan-Larson House'
export const GHOST_SIGNUP_BUTTON_COLOR = '#db695a'

export const PRESS_RELEASE_PDF =
  '/content/docs/Doolan_Larson_Sep_2026_Press Release_FINAL.pdf'

export const PRESS_RELEASE_LETTERHEAD = '/images/Doolan_Larson_ltrhd.jpg'

export const KEXP_PROPOSAL_PDF = '/content/docs/KEXP_260612-DLHS-RFP_Public.pdf'
